/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Posts2Inputs */

const vi_cmspostcategory_posts2 = /** @type {(inputs: Cmspostcategory_Posts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số bài`)
};

/**

* @param {Cmspostcategory_Posts2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_posts2 = /** @type {((inputs?: Cmspostcategory_Posts2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Posts2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_posts2(inputs)
});
export { cmspostcategory_posts2 as "cmsPostCategory_posts" }